import EsimMargin from "../../components/esim/margin/EsimMargin";

const EsimMarginPage: React.FC = () => <EsimMargin />;

export default EsimMarginPage;
